import { OktaAuth } from "@okta/okta-auth-js";
import { removeFromStorage, setToStorage } from "./sessionStorageHelper";

const config = {
  issuer: `${process.env.REACT_APP_OKTA_DOMAIN}oauth2/${process.env.REACT_APP_OKTA_ISSUER_ID}`,
  clientId: process.env.REACT_APP_OKTA_CLIENT_ID,
  storage: "sessionStorage",
};

const responseType = ["token", "id_token"];
const scopes = ["openid", "profile", "customer", "email"];
const idTokenKey = "idToken";
const accessTokenKey = "accessToken";
const authenticateKey = "authenticate";
const profileKey = "profile";

const auth = new OktaAuth(config);

const authClient = {
  login: ({ id, password }) =>
    auth
      .signInWithCredentials({
        username: id,
        password,
      })
      .then((transaction) => {
        switch (transaction.status.toLowerCase()) {
          case "success":
            return auth.token.getWithRedirect({
              redirectUri: `${window.location.protocol}//${window.location.host}${window.location.pathname}`,
              sessionToken: transaction.sessionToken,
              responseType,
              scopes,
            });
          case "locked_out":
            return new Error(
              `You are temporarily locked out as you've input too many wrong passwords.`,
            );
          default:
            return Promise.reject(
              new Error(
                `Transaction status: ${transaction.status} is not expected`,
              ),
            );
        }
      }),

  parseTokensAndGetProfile: () => {
    if (auth.isLoginRedirect()) {
      return auth.token
        .parseFromUrl()
        .then((tokenResponse) => {
          const { tokens } = tokenResponse;
          const { idToken, accessToken } = tokens;
          const authenticate = {};
          if (idToken) {
            auth.tokenManager.add(idTokenKey, idToken);
            authenticate.idToken = idToken.idToken;
          }
          if (accessToken) {
            auth.tokenManager.add(accessTokenKey, accessToken);
            authenticate.accessToken = accessToken.accessToken;
          }
          setToStorage(authenticateKey, authenticate);
        })
        .then(() => auth.token.getUserInfo());
    }

    return auth.token.getUserInfo();
  },
  // logout user from okta and redirect, default redirect uri is /login
  logout: ({ redirectTo }) =>
    auth
      .signOut({
        postLogoutRedirectUri: `${window.location.origin}/${redirectTo}`,
      })
      .then(() => {
        removeFromStorage(authenticateKey);
        removeFromStorage(profileKey);
      }),

  isLoginRedirect: () => auth.isLoginRedirect(),
};

export { authClient };
